<script>
    import {onMount} from 'svelte';

    export let startTime = '';
    export let endTime = '';
    export let title = '';
    export let englishTitle = '';
    export let types = '';
    export let typeId = '';
    export let wytyczne_id = [];
    export let id = '';

    export let letter = '';

    let duration = 0;
    let height = '0px';
    let isHovered = false;
    let type = '';
    let minHeight = 0;
    let adjustedTop = '0px';
    let isOverflowing = false;
    let eventBox;
    let contentBox;
    let zIndex = 0;

    const calculateDuration = (startTime, endTime) => {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        const [endHours, endMinutes] = endTime.split(':').map(Number);
        const startTotalMinutes = startHours * 60 + startMinutes;
        const endTotalMinutes = endHours * 60 + endMinutes;
        return endTotalMinutes - startTotalMinutes;
    };

    const findObjectByKey = (types, id) => {
        for (const key in types) {
            if (types.hasOwnProperty(key)) {
                if (key === id) {
                    return {[key]: types[key]};
                }
            }
        }
        return null;
    };

    const removeColonZero = (string) => {
        if (string.endsWith(':00')) {
            return string.slice(0, -3);
        }
        return string;
    };

    const extractHour = (time) => {
        const hour = time.split(':')[0];
        return parseInt(hour, 10);
    };

    const MAX_HOUR = 24;

    $: newObj = findObjectByKey(types, typeId);
    $: eventType = newObj ? newObj[typeId]?.name[0] : '';
    $: eventTitle = title;
    $: newStartTime = removeColonZero(startTime);
    $: newEndTime = removeColonZero(endTime);
    $: minHeight = `${(duration / 5) * 10 - 2}px`;
    $: duration = calculateDuration(startTime, endTime);
    $: {
        const computedHeight = (duration / 5) * 10 - 65;
        height = isOverflowing && !isHovered
            ? (computedHeight > 0 ? `${computedHeight}px` : '0px')
            : isHovered
                ? 'auto'
                : (computedHeight > 0 ? `${computedHeight}px` : '0px');
    }

    $: zIndex = MAX_HOUR - extractHour(newStartTime);
    $: checkEventId = wytyczne_id.includes(id.toString())
    $: maxHeight = duration <= 30 ? '88px' : 'none';

    $: {
        if (newStartTime.endsWith('15') || newStartTime.endsWith('45')) {
            adjustedTop = '-30px';
        } else if (newStartTime.endsWith('20') || newStartTime.endsWith('40')) {
            adjustedTop = '15px';
        }
        else {
            adjustedTop = '0px';
        }
    }

    const checkOverflow = () => {
        const {scrollHeight, clientHeight} = eventBox;
        const boundingRect = eventBox.getBoundingClientRect();
        isOverflowing = scrollHeight > boundingRect.height || scrollHeight > clientHeight;
    };

    onMount(() => {
        checkOverflow();
    });
</script>

<div bind:this={eventBox} class='shadow-xl absolute event-box'
     on:mouseenter={() => { isHovered = true; checkOverflow(); }}
     on:mouseleave={() => isHovered = false}
     style="overflow: hidden; min-height: {minHeight}; height: {maxHeight}; background: rgb(254,254,254);
background: linear-gradient(180deg, rgba(254,254,254,1) 0%, rgba(252,243,244,1) 100%); border-radius:3px; width: 90%; margin: 0.5rem; margin-top:0; z-index: {zIndex}; top: {adjustedTop}; display: flex; flex-direction: column;">
    <div class="content-eventbox" bind:this={contentBox} style="flex-grow: 1; display: flex; flex-direction: column;">
        <div class="flex"
             style="background: #bdbdbd; height:25px; color: white; padding:0.3rem; font-size:0.8rem; border-top-left-radius:3px; border-top-right-radius:3px">
            <div style="display: flex">
                <p style="font-weight: bold; margin-left: 0.5rem">{newStartTime} - {newEndTime}</p>
                <p style="margin-left: 0.5rem">({duration} min)</p>
            </div>
            <p style="color: #d2222c; font-weight: bold; margin-left: 1rem">{checkEventId ? 'WYTYCZNE' : ''}</p>
        </div>
        <div style="flex-grow: 1; display: flex; flex-direction: column;">
            <div style="height: {height}">
                <p class=""
                   style="font-size: 12px; padding:0.5rem; padding-bottom: 0; font-weight: bold; color:#3f3e3c; text-align: start">{eventTitle}</p>
                <p class=""
                   style="font-size: 12px; padding:0.5rem; padding-top: 0.2rem; font-style: italic; color:#3f3e3c; text-align: start">{englishTitle}</p>
            </div>
            <div style="margin-top: auto; height: 36px; background: #fcf4f5">
                <hr style="border-top: 3px solid rgb(229 231 235);"/>
                {#if eventType.length !== 0}
                    <div style="height: 100%; display: flex; justify-content: center; align-items: center;">
                        <p class="session_{typeId}"
                           style="font-size: 10px; color:#3f3e3c; font-weight: bold; padding: 0;">
                            {eventType.toUpperCase()}
                        </p>
                    </div>
                {:else}
                    {#each Object.entries(types) as [typeKey, type]}
                        {#if type.letter === letter && type.name && type.name[0]}
                            <div style="height: 100%; display: flex; justify-content: center; align-items: center;">
                                <p class="session_{typeId}"
                                   style="font-size: 10px; color:#3f3e3c; font-weight: bold; padding: 0;">{type.name[0].toUpperCase()}</p>
                            </div>
                        {/if}
                    {/each}
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    @media only screen and (max-width: 600px) {
        .event-box {
            width: 85% !important;
        }
    }
</style>
